module.exports = __webpack_public_path__ + "img/fondo-banner-principal.26513d3d.png";